module.exports = __webpack_public_path__ + "static/media/carta_39.9e6c956e.jpg";